import { OldFilterDTO } from "../application/OldFilterDTO"

export default class EmbalagemHelper {

    public static getFilter(): OldFilterDTO {
        return {
            descricao: { field: "descricao", rule: "contains", value: "%%" }
        }
    }
}